import * as PIXI from "pixi.js";
import gsap from 'gsap';


export default class Rect{

    constructor(graphics, xx, yy, ww){
        this.graphics = graphics;
        this.x = xx;
        this.y = yy;
        this.w = ww;
        this.h = 0;
        this.isTween = false;
    }

    
    update(){

        if(!this.isTween){
            const d = Math.random() * 1 + 2;
            const mw = window.innerWidth * 0.25;
            const mh = window.innerHeight * 0.07;
            gsap.to(this, {duration:2, delay:d, x:`-=${mw/2}`, w:`+=${mw}`, y:`-=${mh/2}`, h:mh, ease:'power4.easeInOut'});
            this.isTween = true;
        }
        
        this.graphics.beginFill(0x000000);
        this.graphics.drawRect(this.x, this.y, this.w, this.h);
    }
}